/* assets/brand-countdown.js */
(function () {
  // Init guard: prevents double-initialization if script is included twice
  if (window.__SMC_TIMER_INITED) return;
  window.__SMC_TIMER_INITED = true;

  function ready(f){ document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',f) : f(); }
  const pad = n => String(n).padStart(2,'0');

  // Headlines – randomized once per session
  const HEADLINES = [
    '10% Extra Off – Sale end soon',
    '10% Extra Off – Time is ticking',
    '10% Extra Off – Limited Offer',
    'Super Sale 10% Extra Off'
  ];

  // === UK windows (BST in Sep = UTC+1). Use UTC to avoid client timezone drift. ===
  const WINDOWS = [
    // 09/09/2025 22:00 → 10/09/2025 09:00 (UK)  == 21:00 → 08:00 UTC
    { start: Date.UTC(2025, 8,  9, 21, 0, 0), end: Date.UTC(2025, 8, 10,  8, 0, 0) },
    // 10/09/2025 18:00 → 11/09/2025 09:00 (UK)  == 17:00 → 08:00 UTC
    { start: Date.UTC(2025, 8, 10, 17, 0, 0), end: Date.UTC(2025, 8, 11,  8, 0, 0) },
    // 12/09/2025 19:00 → 14/09/2025 08:00 (UK)  == 18:00 → 07:00 UTC
    { start: Date.UTC(2025, 8, 12, 18, 0, 0), end: Date.UTC(2025, 8, 14,  7, 0, 0) },
  ];

  function activeWindow(nowUtcMs){
    for (const w of WINDOWS) if (nowUtcMs >= w.start && nowUtcMs < w.end) return w;
    return null;
  }

  ready(function(){
    const root = document.getElementById('smCountdown');
    if (!root) return;
    if (root.dataset.initialized === '1') return; // extra guard if markup repeats
    root.dataset.initialized = '1';

    const $ = sel => root.querySelector(sel);
    const dEl = $('#smDays'), hEl = $('#smHours'), mEl = $('#smMins'), sEl = $('#smSecs');
    if (!(dEl && hEl && mEl && sEl)) return;

    // Random headline (session-sticky)
    const titleEl = $('.smc-title');
    if (titleEl && HEADLINES.length) {
      const key = 'smc_headline_idx';
      let idx = sessionStorage.getItem(key);
      if (idx === null) { idx = String(Math.floor(Math.random() * HEADLINES.length)); sessionStorage.setItem(key, idx); }
      titleEl.textContent = HEADLINES[Number(idx)];
    }

    // Copy button
    const copyBtn = $('#smCopyBtn');
    const codeEl  = $('#smPromoCode');
    copyBtn && copyBtn.addEventListener('click', function(){
      const val = (codeEl?.textContent || '').replace(/^Code:\s*/i,'').trim();
      if (!val) return;
      const done = () => { const prev = copyBtn.textContent; copyBtn.textContent = 'Copied'; setTimeout(()=>copyBtn.textContent = prev || 'Copy', 1200); };
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(val).then(done, fallback); else fallback();
      function fallback(){
        try{
          const r=document.createRange(); r.selectNodeContents(codeEl||root);
          const s=window.getSelection(); s.removeAllRanges(); s.addRange(r); document.execCommand('copy'); s.removeAllRanges();
        } catch(e){}
        done();
      }
    });

    // Ticker: aligns to the second; shows only inside a live window
    function tick(){
      const now = Date.now();      // UTC-based ms epoch
      const live = activeWindow(now);

      if (!live) { root.style.display = 'none'; return; }
      root.style.display = '';

      const remain = Math.max(0, live.end - now);
      if (remain === 0) { root.style.display = 'none'; return; }

      let sec = Math.floor(remain/1000);
      const days = Math.floor(sec/86400); sec -= days*86400;
      const hrs  = Math.floor(sec/3600);  sec -= hrs*3600;
      const mins = Math.floor(sec/60);    sec -= mins*60;

      dEl.textContent = pad(days);
      hEl.textContent = pad(hrs);
      mEl.textContent = pad(mins);
      sEl.textContent = pad(sec);
    }

    (function schedule(){ tick(); setTimeout(schedule, 1000 - (Date.now() % 1000)); })();
  });
})();
